import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import CommonImageComp from "../../components/ui/CommonImageComp";
import { CountdownRing } from "../../components/ui/CountdownRing";
import { OverlaySlot } from "../../components/Wrappers/OverlaySlot";
import { useThemeContext } from "../../globalContext/global-context";
import type { QuestionViewProps } from "../contracts";
import type { ImageDefinition, ImageDraft, ImageEvent } from "./core";

type ViewProps = QuestionViewProps<ImageDefinition, ImageDraft, ImageEvent>;

const timedImageStyle = {
  maxWidth: "100%",
  maxHeight: "calc(100dvh - 10rem)",
  width: "auto",
  height: "auto",
  objectFit: "contain",
};

export const ImageView = (props: ViewProps) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const [open, setOpen] = useState(
    props.active !== false && props.definition.numberSeconds > 0,
  );
  if (props.definition.numberSeconds <= 0) return null;
  return (
    <OverlaySlot
      open={open}
      size="fullscreen"
      ariaLabelledBy="timed-image-title"
    >
      <Box
        data-testid="timed-image-overlay"
        sx={{
          height: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: `${theme.tokens.spacing["4"]}px`,
          padding: `${theme.tokens.spacing["4"]}px`,
        }}
      >
        {props.availableAtMs && (
          <Box
            sx={{
              position: "absolute",
              top: `${theme.tokens.spacing["4"]}px`,
              right: `${theme.tokens.spacing["4"]}px`,
            }}
          >
            <CountdownRing
              availableAtMs={props.availableAtMs}
              durationSeconds={props.definition.numberSeconds}
            />
          </Box>
        )}
        <Typography id="timed-image-title">
          {props.definition.prompt}
        </Typography>
        <CommonImageComp
          currentVal={{
            image: props.definition.image,
            alt_text: props.definition.altText ?? theme.copy.labels.surveyImage,
          }}
          disablePreviewWrapper
          imageTestid="timed-image"
          imageStyle={timedImageStyle}
        />
        <Button
          variant="contained"
          disabled={!props.controls.canSubmit}
          onClick={() => {
            setOpen(false);
            props.submit();
          }}
        >
          {theme.copy.actions.continue}
        </Button>
      </Box>
    </OverlaySlot>
  );
};
